import { useCallback } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { HomeTabSuggestionItem } from '@/../../shared/types/socialTypes';
import defaultProfilePic from '@/assets/profileAnonPicInverse.png';

const SuggestionItem = ({ suggestion }: { suggestion: HomeTabSuggestionItem }) => {
  const navigate = useNavigate({ from: '/' });

  const handleClick = useCallback(() => {
    navigate({ to: '/profile/$uniqId', params: { uniqId: suggestion.data.uniqId } });
  }, [suggestion]);

  return (
    <div
      className="text-white mx-[30px] flex items-center gap-2 rounded-[45px] p-4 cursor-pointer"
      style={{
        border: '0.5px solid #545454',
      }}
      onClick={handleClick}
    >
      <img
        src={suggestion.thumbnailUrl ?? defaultProfilePic}
        alt={suggestion.title}
        className="rounded-full"
        style={{
          objectFit: 'cover',
          width: '40px',
          height: '40px',
        }}
      />
      <p className="text-sm text-start">{suggestion.title}</p>
    </div>
  );
};

export default SuggestionItem;
